import {
  Injector,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { BoelsSeoMetaService } from './boels-seo-meta.service';
import { UrlSafePipe } from '@boels/helpers';
import { htmlLangProvider } from './boels-html-lang-provider';
import { StructuredDataFactory } from './structured-data/structured-data.factory';
import { JsonLdBuilderModule } from './structured-data/builders/json-ld-builder.module';
import { BoelsAlternateLinkService } from './links/boels-alternate-link.service';
import { CanonicalLinkService } from './links/canonical-link.service';
import { JsonLdScriptFactory } from './structured-data/json-ld-script.factory';
import { BoelsAlternatesFacade } from '@boels/shared-state';

export function initSeoService(injector: Injector): () => void {
  return () => {
    const seoService = injector.get(BoelsSeoMetaService);
    seoService.init();
  };
}

export function getStructuredDataFactory(injector: Injector): () => void {
  return () => {
    const factory = injector.get(StructuredDataFactory);
    factory.build();
  };
}

@NgModule({
  imports: [JsonLdBuilderModule],
  providers: [
    JsonLdScriptFactory,
    CanonicalLinkService,
    BoelsAlternateLinkService,
    BoelsAlternatesFacade,
    StructuredDataFactory,
    BoelsSeoMetaService,
    provideAppInitializer(() => {
      const initializerFn = initSeoService(inject(Injector));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = getStructuredDataFactory(inject(Injector));
      return initializerFn();
    }),
    htmlLangProvider,
    UrlSafePipe,
  ],
})
export class SeoModule {}
